import React from 'react';
import { COLOR } from '@src/styles/color';
import { Skeleton } from '@mui/material';
import Typography from '@src/new-components/Typography';
import PodiumImg from '@src/assets/images/podium.png';
import { StyledPodiumImg, StyledPodiumItem } from '../index.style';
import Frame from './Frame';
import VoiceDataInfo from './VoiceDataInfo';
import ActionsVoice from './ActionsVoice';

const getPodiumStyles = (rank) => {
  // rank: 1 (gold), 2 (silver), 3 (copper)
  switch (rank) {
    case 1:
      return {
        container: { marginTop: 0, zIndex: 2, marginTopActions: 72 },
      };
    case 2:
      return {
        container: { marginTop: 46, zIndex: 1, marginTopActions: 26 },
      };
    case 3:
    default:
      return {
        container: { marginTop: 72, zIndex: 0, marginTopActions: 0 },
      };
  }
};

const PodiumItem = ({
  voice,
  isPlaying,
  onPlayAudio,
  onPauseAudio,
  isLoading,
  favouriteVoiceCodes,
  onFavoriteToggleRequest,
  onHandleFavoriteProcessingComplete,
  onErrorProcessingFavouriteVoices,
  setFavouriteVoiceCodes,
}) => {
  const rank = voice?.rank || 3; // default to 3 if not provided
  const styles = getPodiumStyles(rank);

  const renderNameVoice = () => {
    if (isLoading) {
      return (
        <Skeleton
          style={{ borderRadius: '50px' }}
          variant="rectangular"
          width={115}
          height={30}
        />
      );
    }
    return (
      <Typography
        className="name-voice"
        variant="body-24-bold"
        color={COLOR.descriptionGray}
      >
        {voice?.name || '???'}
      </Typography>
    );
  };

  return (
    <StyledPodiumItem style={styles.container}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '8px',
        }}
      >
        <Frame
          voice={voice}
          isPlaying={isPlaying}
          onPlayAudio={onPlayAudio}
          onPauseAudio={onPauseAudio}
          isLoading={isLoading}
        />
        {renderNameVoice()}
      </div>
      <div style={{ position: 'relative' }}>
        <StyledPodiumImg src={PodiumImg} alt="Podium" />
        <VoiceDataInfo voice={voice} isLoading={isLoading} />
        <ActionsVoice
          isLoading={isLoading}
          voice={voice}
          style={styles.container}
          isFavourite={favouriteVoiceCodes?.includes(voice?.code)}
          onFavoriteToggleRequest={onFavoriteToggleRequest}
          onHandleFavoriteProcessingComplete={
            onHandleFavoriteProcessingComplete
          }
          onErrorProcessingFavouriteVoices={onErrorProcessingFavouriteVoices}
          setFavouriteVoiceCodes={setFavouriteVoiceCodes}
        />
      </div>
    </StyledPodiumItem>
  );
};

export default PodiumItem;
